'use strict';

module.exports = function (value) {
  return JSON.parse(JSON.stringify(value));
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/~/braintree-web/lib/json-clone.js
// module id = 829
// module chunks = 0